import React from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import CancelButton from "presentation/components/buttons/cancel";


import coursesService from "presentation/services/courses";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import { handleChange, directChangeField } from "presentation/utils/functions/generic";

class ClassroomForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            localLoading: true,
            localError: false,
            message: '',
            courses: [],
            topics: []
        }
    }

    async componentDidMount() {
        await this.loadData();
    }

    loadData = async () => {
        let courses = [];
        let localError = false;
        let localLoading = true;
        let errorMessages = [];
        let message = '';

        try {

            await coursesService.findAll().then(async (result) => {
                if (result.error == true) {
                    localError = true;
                    errorMessages.push("Não foi possível recuperar a listagem de cursos...");
                } else {
                    if (result.length <= 0) {
                        localError = true;
                        errorMessages.push("Por favor, cadastre cursos uma turma...");
                    } else {
                        courses = result;
                    }
                }
            });

            if (localError === true) {
                localLoading = false;
                message = errorMessages.join(" / ");
            } else {
                localError = false;
                localLoading = false;

            }
            this.setState({ ...this.state, courses: courses, localError: localError, localLoading: localLoading, message: message });
        } catch (err) {
            this.setState({
                localLoading: false,
                localError: true,
                message: err.message
            });
        }
    }

    handleCourseChange = async (e, component) => {
        const courseId = e.target.value;
        const { courses } = this.state;
        const course = courses.find(x => x.id == courseId);
        await directChangeField('academicPeriodId', course.academicPeriodId, component);
    }

    render() {
        var { localLoading, localError, message, courses } = this.state;
        var { loading, form, handleSubmit, component } = this.props;
        var { handleCourseChange } = this;


        return (
            <>
                {loading === true || localLoading === true && <PageLoadingIndicator loadingText={"Carregando informações..."} />}
                {(localLoading === false && localError === true) && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                {
                    loading === false && localLoading === false && (

                        <Form>
                            <h4>Informações da turma</h4>
                            <div className="form mt-2">
                                <Form.Label htmlFor="discipline">Curso</Form.Label>
                                <Form.Select
                                    aria-label="Curso"
                                    defaultValue={form.courseId}
                                    id="courseId"
                                    name="courseId"
                                    onChange={async (e) => handleChange(e, component, 'form', await handleCourseChange(e, component))}
                                    aria-describedby="courseIdHelpBlock"
                                    required
                                >
                                    <option>Selecione um curso</option>
                                    {courses.map((e, i) => { return <option key={e.id} value={e.id}>{e.name}</option> })}
                                </Form.Select>
                                <Form.Text id="courseIdHelpBlock" muted>
                                    Defina qual o curso da turma
                                </Form.Text>
                            </div>
                            <div className="form">
                                <Form.Label htmlFor="name">Nome da turma</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="name"
                                    name="name"
                                    defaultValue={form.name}
                                    onChange={(e) => handleChange(e, component)}
                                    aria-describedby="nameHelpBlock"
                                />
                                <Form.Text id="nameHelpBlock" muted>
                                    Informe nome da turma
                                </Form.Text>
                            </div>
                            <div className="form mt-2">
                                <Form.Label htmlFor="displayName">Nome de exibição da turma</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="displayName"
                                    name="displayName"
                                    defaultValue={form.displayName}
                                    onChange={(e) => handleChange(e, component)}
                                    aria-describedby="displayNameHelpBlock"
                                />
                                <Form.Text id="displayNameHelpBlock" muted>
                                    Escolha um nome de exibição
                                </Form.Text>
                            </div>
                            <div className="form mt-2">
                                <Form.Label htmlFor="displayName">Código da turma</Form.Label>
                                <Form.Control
                                    type="text"
                                    id="code"
                                    name="code"
                                    defaultValue={form.code}
                                    onChange={(e) => handleChange(e, component)}
                                    aria-describedby="codeHelpBlock"
                                />
                                <Form.Text id="codeHelpBlock" muted>
                                    Escolha um código
                                </Form.Text>
                            </div>
                            <div className="mt-3">
                                <CancelButton
                                    containerProps={{
                                        as: Link,
                                        to: `/turmas`
                                    }}
                                />
                                <Button disabled={loading || localError} variant="success" className="float-end" onClick={() => handleSubmit()}>Salvar</Button>
                            </div>
                        </Form>
                    )
                }
            </>
        );
    };
}

export default ClassroomForm;